module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.0.0-66.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.0.0.md
// module id = 482
// module chunks = 380